import { D as DialogComponent } from "./dialog-njA3j9df.js";
import { d as defineCustomElement } from "./utilities-D68o91ht.js";
import "./component-CZdU8SYg.js";
import "./events-C4hlH4zR.js";
class MobileMenuComponent extends DialogComponent {
  requiredRefs = ["panels"];
  // Stack stores the history of opened panel IDs
  // Starts with the main menu panel
  stack = ["menu-main"];
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this.#handleClick);
    this.#initializePanels();
  }
  /**
   * Initialize all panels to their default state
   */
  #initializePanels() {
    const allPanels = this.refs.panels.querySelectorAll("[data-menu-panel]");
    allPanels.forEach((panel) => {
      if (panel.id === "menu-main") {
        panel.setAttribute("data-state", "active");
      } else {
        panel.setAttribute("data-state", "closed");
      }
    });
  }
  /**
   * Central click handler for all menu interactions
   */
  #handleClick = (e) => {
    const trigger = e.target.closest("[data-menu-target]");
    if (trigger) {
      e.preventDefault();
      const targetId = trigger.dataset.menuTarget;
      this.#openPanel(targetId);
      return;
    }
    const backBtn = e.target.closest("[data-menu-back]");
    if (backBtn) {
      e.preventDefault();
      this.#goBack();
      return;
    }
  };
  /**
   * Open a new panel and add it to the stack
   * @param {string} id - The ID of the panel to open
   */
  #openPanel(id) {
    const nextPanel = this.refs.panels.querySelector(`#${id}`);
    if (!nextPanel) {
      console.warn("Panel not found:", id);
      return;
    }
    this.stack.push(id);
    this.#updatePanelStates();
    setTimeout(() => {
      const firstFocusable = nextPanel.querySelector("[data-menu-back], a, button");
      if (firstFocusable) {
        firstFocusable.focus();
      }
    }, 50);
  }
  /**
   * Go back to the previous panel in the stack
   */
  #goBack() {
    if (this.stack.length <= 1) {
      return;
    }
    const previousId = this.stack[this.stack.length - 2];
    const previousPanel = this.refs.panels.querySelector(`#${previousId}`);
    if (!previousPanel) {
      return;
    }
    this.stack.pop();
    this.#updatePanelStates();
    setTimeout(() => {
      if (previousPanel) {
        const firstFocusable = previousPanel.querySelector("button, a");
        if (firstFocusable) {
          firstFocusable.focus();
        }
      }
    }, 50);
  }
  /**
   * Update all panel states based on current stack
   * Panels in the stack are visible (behind state), top panel is active
   */
  #updatePanelStates() {
    const activeId = this.stack[this.stack.length - 1];
    const allPanels = this.refs.panels.querySelectorAll("[data-menu-panel]");
    allPanels.forEach((panel) => {
      const panelIndex = this.stack.indexOf(panel.id);
      if (panel.id === activeId) {
        panel.setAttribute("data-state", "active");
      } else if (panelIndex >= 0) {
        panel.setAttribute("data-state", "behind");
      } else {
        panel.setAttribute("data-state", "closed");
      }
    });
  }
  /**
   * Reset all panels when dialog closes
   */
  closeDialog() {
    return super.closeDialog().then(() => {
      this.stack = ["menu-main"];
      this.#initializePanels();
    });
  }
}
defineCustomElement("mobile-menu-component", MobileMenuComponent);
